import { LBBOutboundContact } from 'sb-lib/types';
import { SalesfloorRoom } from './salesfloor';

export enum OutboundAMDState {
  AUTO = 'auto',
  OFF = 'off',
  ON = 'on',
}

export enum TwilioCompanyType {
  PRIVATE = 'Private',
  // PUBLIC = 'Public', # need Ticker and Exchange
  // NON_PROFIT = 'Non-Profit',
  // GOVERNMENT = 'Government',
}

export enum TwilioBusinessType {
  SOLE_PROPRIETORSHIP = 'Sole Proprietorship',
  PARTNERSHIP = 'Partnership',
  CORPORATION = 'Corporation',
  LLC = 'Limited Liability Corporation',
  COOP = 'Co-operative',
  NON_PROFIT = 'Non-Profit',
  LLP = 'Limited Liability Partnership',
}

export enum TwilioBusinessIndustry {
  AUTOMOTIVE = 'AUTOMOTIVE',
  AGRICULTURE = 'AGRICULTURE',
  BANKING = 'BANKING',
  CONSUMER = 'CONSUMER',
  EDUCATION = 'EDUCATION',
  ENGINEERING = 'ENGINEERING',
  ENERGY = 'ENERGY',
  OIL_AND_GAS = 'OIL_AND_GAS',
  FAST_MOVING_CONSUMER_GOODS = 'FAST_MOVING_CONSUMER_GOODS',
  FINANCIAL = 'FINANCIAL',
  FINTECH = 'FINTECH',
  FOOD_AND_BEVERAGE = 'FOOD_AND_BEVERAGE',
  GOVERNMENT = 'GOVERNMENT',
  HEALTHCARE = 'HEALTHCARE',
  HOSPITALITY = 'HOSPITALITY',
  INSURANCE = 'INSURANCE',
  LEGAL = 'LEGAL',
  MANUFACTURING = 'MANUFACTURING',
  MEDIA = 'MEDIA',
  ONLINE = 'ONLINE',
  RAW_MATERIALS = 'RAW_MATERIALS',
  REAL_ESTATE = 'REAL_ESTATE',
  RELIGION = 'RELIGION',
  RETAIL = 'RETAIL',
  JEWELRY = 'JEWELRY',
  TECHNOLOGY = 'TECHNOLOGY',
  TELECOMMUNICATIONS = 'TELECOMMUNICATIONS',
  TRANSPORTATION = 'TRANSPORTATION',
  TRAVEL = 'TRAVEL',
  ELECTRONICS = 'ELECTRONICS',
  NOT_FOR_PROFIT = 'NOT_FOR_PROFIT',
}

export enum TwilioBusinessIndustryDisplayValues {
  AUTOMOTIVE = 'Automotive',
  AGRICULTURE = 'Agriculture',
  BANKING = 'Banking',
  CONSUMER = 'Consumer',
  EDUCATION = 'Education',
  ENGINEERING = 'Engineering',
  ENERGY = 'Energy',
  OIL_AND_GAS = 'Oil and Gas',
  FAST_MOVING_CONSUMER_GOODS = 'Fast Moving Consumer Goods',
  FINANCIAL = 'Financial',
  FINTECH = 'Fintech',
  FOOD_AND_BEVERAGE = 'Food and Beverage',
  GOVERNMENT = 'Governmnent',
  HEALTHCARE = 'Healthcare',
  HOSPITALITY = 'Hospitality',
  INSURANCE = 'Insurance',
  LEGAL = 'Legal',
  MANUFACTURING = 'Manufacturing',
  MEDIA = 'Media',
  ONLINE = 'Online',
  RAW_MATERIALS = 'Raw Materials',
  REAL_ESTATE = 'Real Estate',
  RELIGION = 'Religion',
  RETAIL = 'Retail',
  JEWELRY = 'Jewelry',
  TECHNOLOGY = 'Technology',
  TELECOMMUNICATIONS = 'Telecommunications',
  TRANSPORTATION = 'Transportation',
  TRAVEL = 'Travel',
  ELECTRONICS = 'Electronics',
  NOT_FOR_PROFIT = 'Not-for-profit',
}

export enum TwilioBusinessIdentifier {
  DUNS = 'USA: DUNS Number (Dun & Bradstreet)',
  EIN = 'USA: Employer Identification Number (EIN)',
}

export enum TwilioRepresentativePosition {
  Director = 'Director',
  GM = 'GM',
  VP = 'VP',
  CEO = 'CEO',
  CFO = 'CFO',
  GENERAL_COUNSEL = 'General Counsel',
}

export enum CallVisibility {
  HIDDEN = 'hidden',
  MINIMIZED = 'minimized',
  VISIBLE = 'visible',
}

export enum SourceType {
  APOLLO_SEQUENCE = 'apollo_sequence',
  APOLLO_TASK = 'apollo_task',
  CONTACT = 'contact',
  DIALPAD = 'dialpad',
  HUBSPOT_LIST = 'hubspot_list',
  HUBSPOT_TASK = 'hubspot_task',
  OUTREACH_SEQUENCE = 'outreach_sequence',
  OUTREACH_TASK = 'outreach_task',
  SALESFORCE_REPORT = 'salesforce_report',
  SALESLOFT_CADENCE = 'salesloft_cadence',
  SALESLOFT_TASK = 'salesloft_task',
  SERVICEBELL_LIST = 'servicebell_list',
}

export const LIST_SOURCE_TYPES = [
  SourceType.APOLLO_SEQUENCE,
  SourceType.HUBSPOT_LIST,
  SourceType.OUTREACH_SEQUENCE,
  SourceType.SALESFORCE_REPORT,
  SourceType.SALESLOFT_CADENCE,
  SourceType.SERVICEBELL_LIST,
];
export const TASK_SOURCE_TYPES = [
  SourceType.HUBSPOT_TASK,
  SourceType.OUTREACH_TASK,
  SourceType.SALESLOFT_TASK,
];

export const APOLLO_SOURCE_TYPES = [SourceType.APOLLO_SEQUENCE, SourceType.APOLLO_TASK];
export const HUBSPOT_SOURCE_TYPES = [SourceType.HUBSPOT_LIST, SourceType.HUBSPOT_TASK];
export const OUTREACH_SOURCE_TYPES = [
  SourceType.OUTREACH_SEQUENCE,
  SourceType.OUTREACH_TASK,
];
export const SALESFORCE_SOURCE_TYPES = [SourceType.SALESFORCE_REPORT];
export const SALESLOFT_SOURCE_TYPES = [
  SourceType.SALESLOFT_CADENCE,
  SourceType.SALESLOFT_TASK,
];
export const SERVICEBELL_SOURCE_TYPES = [SourceType.SERVICEBELL_LIST];

export enum DialStyle {
  POWER_DIAL = 'power-dial',
  PARALLEL_DIAL = 'parallel-dial',
}

export enum CallTaskStatus {
  ANSWERED = 'answered',
  BAD_NUMBER = 'bad-number',
  BUSY = 'busy',
  CANCELED = 'canceled',
  COMPLETED = 'completed',
  DIALING = 'dialing',
  ERROR = 'error',
  FAILED = 'failed',
  INITIATED = 'initiated',
  IN_PROGRESS = 'in-progress',
  LEFT_VOICEMAIL = 'left-voicemail',
  NO_ANSWER = 'no-answer',
  NO_NUMBER = 'no-number',
  PENDING = 'pending',
  RETRY = 'retry',
  RINGING = 'ringing',
  SKIPPED = 'skipped',
}

export const FailedCallTaskStates = [
  CallTaskStatus.BAD_NUMBER,
  CallTaskStatus.BUSY,
  CallTaskStatus.CANCELED,
  CallTaskStatus.ERROR,
  CallTaskStatus.FAILED,
  CallTaskStatus.NO_ANSWER,
  CallTaskStatus.NO_NUMBER,
];

export const UnansweredCallTaskStates = [
  CallTaskStatus.LEFT_VOICEMAIL,
  ...FailedCallTaskStates,
];

export type UnansweredCallTaskState = typeof UnansweredCallTaskStates[number];

export const CompletedCallTaskStates = [
  CallTaskStatus.COMPLETED,
  CallTaskStatus.LEFT_VOICEMAIL,
  ...FailedCallTaskStates,
];

export const InProgressCallTaskStates = [
  CallTaskStatus.ANSWERED,
  CallTaskStatus.DIALING,
  CallTaskStatus.INITIATED,
  CallTaskStatus.IN_PROGRESS,
  CallTaskStatus.RETRY,
  CallTaskStatus.RINGING,
];

export const ConnectedCallTaskStates = [
  CallTaskStatus.ANSWERED,
  CallTaskStatus.IN_PROGRESS,
];

export const PendingCallTaskStates = [CallTaskStatus.PENDING];

// Current used for both Trusthub and Business Profile status
export enum TrusthubApprovalStatus {
  NOT_SUBMITTED = 'not-submitted',
  DRAFT = 'draft',
  PENDING_REVIEW = 'pending-review',
  IN_REVIEW = 'in-review',
  TWILIO_REJECTED = 'twilio-rejected',
  TWILIO_APPROVED = 'twilio-approved',
  PROVISIONALLY_APPROVED = 'provisionally-approved',
}

export enum DialSessionStatus {
  OPEN = 'open',
  CLOSED = 'closed',
}

export interface TrusthubRegistrationBody {
  customerName: string;
  email: string;
  street: string;
  city: string;
  state: string;
  postalCode: string;
  businessName: string;
  businessType: TwilioBusinessType;
  businessIndustry: TwilioBusinessIndustry;
  businessRegistrationIdentifier: TwilioBusinessIdentifier;
  businessRegistrationNumber: string;
  businessWebsiteUrl: string;
  representativeFirstName: string;
  representativeLastName: string;
  representativeEmail: string;
  representativePhoneNumber: string;
  representativeTitle: string;
  representativePosition: TwilioRepresentativePosition;
}

export interface CallDisposition {
  id: string;
  label: string;
  deleted: boolean;
}

export interface CallSentiment {
  id: string;
  label: string;
}

export interface TwilioTokenResponse {
  token: string;
  identity: string;
}

export interface ContactListCallTasksResponse {
  approximateCount: number | null;
  callTasks: CallTask[];
  cursor: any;
}

export interface OnboardingStatus {
  businessProfileStatus: TrusthubApprovalStatus;
  ssTrustProductStatus: TrusthubApprovalStatus;
  viTrustProductStatus: TrusthubApprovalStatus;
  bcidTrustProductStatus: TrusthubApprovalStatus;
  cnamTrustProductStatus: TrusthubApprovalStatus;
  isTrusthubRegistered: boolean;
  isTrusthubVerified: boolean;
  isApolloIntegrationSetup: boolean;
  isHubspotIntegrationSetup: boolean;
  isOutreachIntegrationSetup: boolean;
  isSalesforceIntegrationSetup: boolean;
  isSalesloftIntegrationSetup: boolean;
}

export interface CallTask {
  attemptedNumbers?: string[];
  callSid?: string;
  contact: LBBOutboundContact;
  externalContactId?: string;
  frontendId: string;
  id?: string;
  invalidNumbers?: string[];
  shouldRecord?: boolean;
  sourceId: number;
  sourceType: SourceType;
  status: CallTaskStatus;
  userId?: number;
}

export interface ContactList {
  id: number;
  name: string;
  service: string;
  kind?: string;
}

export interface ProspectProperty {
  propertyKey: string;
  displayName: string;
  visible: boolean;
  readOnly: boolean;
  type: string;
}

export interface ContactListSchema {
  prospectProperties: ProspectProperty[];
}

export interface TwilioPhoneNumber {
  phoneNumber: string;
  friendlyName: string;
  postalCode: string;
  locality: string;
  region: string;
}

export interface PhoneNumber {
  sid: string;
  phoneNumber: string;
  friendlyName: string;
  isSpam: boolean | null;
}

export interface DialSession {
  id: number;
  userId: number;
  orgId: number;
  sourceType: SourceType;
  sourceId?: number;
  startingTaskCount: number;
  status: DialSessionStatus;
  dateCreated: Date;
  dateUpdated: Date;
  dateClosed: Date;
  tasksStarted?: DialTask[];
  liveListenRoom?: SalesfloorRoom;
}

export interface DialTask {
  callDuration?: number;
  callSid: string | null;
  calledFrom: string;
  contact: LBBOutboundContact;
  contactId: number;
  dateCreated?: string;
  dateUpdated?: string;
  frontendId: string;
  id: string;
  name: string | null;
  number: string | null;
  invalidNumbers: string[];
  attemptedNumbers: string[];
  orgId: number;
  recordingUrl?: string;
  session?: DialSession;
  sessionId: number;
  sourceId: number | null;
  shouldRecord: boolean;
  sourceType: SourceType;
  status: CallTaskStatus;
}

export interface OutboundCallReport {
  userId: number;
  orgId: number;
  notes?: string;
  direction: 'INBOUND' | 'OUTBOUND';
  dateCreated: string;
  dialTask: DialTask | null;
  contact: LBBOutboundContact;
  externalServiceDispositionId?: string;
}

export interface OutboundVoicemailRecording {
  orgId: number;
  userId: number;
  id: number;
  signedUrl: string;
  title: string;
  usageCount: number;
}

export interface OutboundTranscription {
  dateCreated: string;
  dateUpdated: string;
  dialTaskId: string;
  id: number;
  orgId: number;
  status: 'started' | 'error' | 'complete';
  summary: null;
  results: OutboundTranscriptionMessage[];
}

export interface OutboundTranscriptionMessage {
  transcript: string;
  id: string;
  channel: 'inbound' | 'outbound';
  startTime: number;
  endTime: number;
  transcriptionId: number;
  transcription: OutboundTranscription;
}
